var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgThumbsUpCircleSecond(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 39,
    viewBox: "0 0 39 39",
    width: 39,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-5 -4)"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "#181818",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.5 22.842v6.736"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.29 28.316c0 .9300475.7539525 1.6839975 1.684 1.6839975h7.044c.562837.0003017 1.0884296-.2812658 1.4-.7499975l1.8-2.704c.1840452-.2774584.28214-.6030499.2820001-.936v-3.294c0-.4466246-.177421-.8749566-.4932323-1.1907678-.3158112-.3158113-.7441432-.4932322-1.1907678-.4932322h-3.116v-2.864c0-.9764394-.7915606-1.7680025-1.768-1.7680025h-1.01c-.5924209-.0010074-1.1416891.3097128-1.446.8180025l-2.706 4.512c-.3139326.5231962-.4798402 1.121846-.48 1.732z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.26294 34.31652-1.26294 5.68348 5.68348-1.26294c7.6562613 5.3639667 18.1425473 3.9855206 24.1524501-3.1748944 6.0099029-7.1604151 5.5492558-17.7268768-1.0609816-24.3371141-6.6102373-6.61023735-17.176699-7.07088449-24.3371141-1.0609816-7.16041497 6.0099028-8.5388611 16.4961888-3.1748944 24.1524501z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpCircleSecond);
export default __webpack_public_path__ + "static/media/thumbs-up-circle-second.83d9d2567bf958c0cffe34f103cdda01.svg";
export { ForwardRef as ReactComponent };